export const ROUTE_HOME = 'Home'
export const ROUTE_LOGIN = 'Login'
export const ROUTE_404 = 'NotFound'
